export default __webpack_public_path__ + "static/media/4.9c3d566f.jpg";